import React, { useState } from "react";
import Http from "../Common/Http";
import IsLogin from "../Common/IsLogin";
import "./login.css";

const BRAND_LOGO = `${process.env.PUBLIC_URL}/ldl-logo.png`;

const Login = () => {
  const [inputs, setInputs] = useState({ email: "", password: "" });
  const [message, setMessage] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage(undefined);
    Http.post("/login", inputs)
      .then((res) => {
        localStorage.setItem("token", res.data.token);
        sessionStorage.setItem("token", res.data.token);
        window.location.href = "/dashboard";
      })
      .catch(function (e) {
        setMessage(e.response?.data?.message || "Unable to sign in. Please check your connection and try again.");
        setSubmitting(false);
      });
  };

  return (
    <div className="erp-login">
      <IsLogin></IsLogin>

      <main className="erp-login__main">
        <div className="erp-login__card">
          <div className="erp-login__brand">
            <img src={BRAND_LOGO} alt="Limerick Distribution Ltd." />
          </div>

          <div className="erp-login__body">
            <h1>Sign in to your account</h1>
            <p className="erp-login__sub">Enter your email and password to continue.</p>

            {message && (
              <div className="erp-login__alert" role="alert">
                <i className="fa fa-exclamation-circle" aria-hidden="true" />
                <span>{message}</span>
              </div>
            )}

            <form onSubmit={formSubmit}>
              <label className="erp-login__field">
                <span>Email address</span>
                <div className="erp-login__input">
                  <i className="fa fa-envelope-o" aria-hidden="true" />
                  <input
                    type="email"
                    name="email"
                    value={inputs.email}
                    onChange={handleChange}
                    placeholder="name@limerickbd.com"
                    autoComplete="username"
                    autoFocus
                    required
                  />
                </div>
              </label>

              <label className="erp-login__field">
                <span>Password</span>
                <div className="erp-login__input">
                  <i className="fa fa-lock" aria-hidden="true" />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={inputs.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    required
                  />
                  <button
                    type="button"
                    className="erp-login__toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} aria-hidden="true" />
                  </button>
                </div>
              </label>

              <button type="submit" className="erp-login__submit" disabled={submitting}>
                {submitting ? (
                  <>
                    <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Signing in…
                  </>
                ) : (
                  "Sign in"
                )}
              </button>
            </form>
          </div>

          <div className="erp-login__note">
            <i className="fa fa-shield" aria-hidden="true" />
            <span>Authorised personnel only. Forgot your password? Contact your system administrator.</span>
          </div>
        </div>

        <p className="erp-login__footer">
          &copy; {new Date().getFullYear()}{" "}
          <a href="https://limerickbd.com" target="_blank" rel="noreferrer">
            Limerick Resources Limited
          </a>
          . All rights reserved.
        </p>
      </main>
    </div>
  );
};

export default Login;
